import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useHistory } from "react-router";
import PaymentMethod from "../../AccountSettings/PaymentMethod";
import ShippingAddress from "../../AccountSettings/ShippingAddress";
import UnderlinedButton from "../../common/UnderlinedButton";
import styles from "./styles.module.scss";
const ShippingAndBilling = () => {
    const history = useHistory();
    const goToAccountSettings = (link) => {
        history.push(`/app/settings${link}`);
    };
    return (_jsxs("div", { className: styles.shipping_billing, children: [_jsxs("div", { className: styles.shipping, children: [_jsx(ShippingAddress, { noEdit: true }), _jsx(UnderlinedButton, { dataAttr: "subscription-shipping-button", onClick: () => goToAccountSettings("#shipping"), label: "Add Address" })] }), _jsxs("div", { className: styles.billing, children: [_jsx(PaymentMethod, { noEdit: true }), _jsx(UnderlinedButton, { dataAttr: "subscription-payment-method-button", onClick: () => goToAccountSettings("#paymentMethod"), label: "Add Payment Method" })] })] }));
};
export default ShippingAndBilling;
